import React, { useContext } from 'react';
import Button from 'react-bootstrap/Button';
import RootStoreContext from '../model/RootStoreContext';
import type { IGameEnvironment } from '../model/gameEnvironment/GameEnvironment';
import { CustomSpinner } from '@yakoffice/custom-spinner';
import { FormattedErrorMessage } from '../presentation/views/common/Utils';
import { useShowModal } from '@yakoffice/custom-modal';
import { Alert } from 'react-bootstrap';


export interface IGameEnvironmentController {
    saveGameEnvironment: () => void,
    deleteGameEnvironment: () => void
}


interface useGameEnvironmentControllerProps {
    setGameEnvironmentEditStatus: (edited: boolean) => void;
    gameEnvironment: IGameEnvironment;
    updateCallbackTrigger: (clearActiveGameEnvironment?: boolean) => void;
}

export const GameEnvironmentController = (props: useGameEnvironmentControllerProps) => {

    // Context Hooks
    const showModal = useShowModal();
    const rootStore = useContext(RootStoreContext);

    // Handlers
    const saveGameEnvironment = () => {

        rootStore.gameEnvironmentsStore.saveGameEnvironment(props.gameEnvironment)
            .then(async () => {
                props.setGameEnvironmentEditStatus(false);
                props.updateCallbackTrigger();
            })
            .catch(e => {
                showModal({
                    show: true,
                    title: 'Error saving game environment',
                    body: <FormattedErrorMessage errorMessage={e.message} />,
                    canClose: true
                });
            });
    };

    const deleteGameEnvironment = () => {

        const confirmDeleteGameEnvironment = () => {

            showModal(
                {
                    show: true,
                    title: 'Delete Game Environment',
                    body: <CustomSpinner spinnerText={`Deleting Game Environment`} position={'relative'} />,
                    canClose: false
                }
            );

            rootStore.gameEnvironmentsStore.deleteGameEnvironment(props.gameEnvironment)
                .then(async () => {
                    props.setGameEnvironmentEditStatus(false);
                    showModal({ body: '', canClose: false, title: '', show: false });
                    props.updateCallbackTrigger(true);
                })
                .catch(e => {
                    showModal({
                        show: true,
                        title: 'Error deleting game environment',
                        body: <FormattedErrorMessage errorMessage={e.message} />,
                        canClose: true
                    });
                });
        };

        showModal(
            {
                show: true,
                title: 'Delete Game Environment',
                body: <div><Alert variant="danger"><strong>WARNING: </strong>This actions
                    is <strong>irreversible.</strong> It is strongly recommended that you create a manual backup of the
                    MySQL database instance before proceeding.
                </Alert>
                    <span>Are you sure you want to delete this game environment? This will remove all experiments, distributions, and entities associated with this environment.</span>
                </div>,
                action: <Button variant="danger" onClick={() => confirmDeleteGameEnvironment()}
                                data-testid="btnModalConfirmDelete">Delete</Button>,
                canClose: true
            }
        );
    };

    const controller: IGameEnvironmentController = {
        saveGameEnvironment,
        deleteGameEnvironment
    };

    return controller;
};
